import React from "react";
import { Icon } from "@evidenceb/athena-common/design-system/Icon";
import cn from "classnames";
import { ResourceMiniatureProps } from "./types";

import "./ResourceMiniature.scss";

const ResourceMiniature = ({
    className,
    onClick,
    draggable = false,
    children,
    inlineStartElement,
    active = false,
}: ResourceMiniatureProps) => {
    const Container = onClick ? "button" : "div";

    return (
        <Container
            className={cn(
                "resource-miniature",
                {
                    "--has-inline-start-element": !!inlineStartElement,
                    "--has-draggable-icon": draggable,
                    "--active": active,
                },
                className
            )}
            /* @ts-ignore its ok because type checking is done above*/
            onClick={onClick}
        >
            {inlineStartElement && <div>{inlineStartElement}</div>}
            <div className="resource-miniature__content">{children}</div>
            {draggable && <Icon path="drag" />}
        </Container>
    );
};
export default ResourceMiniature;
